import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useLocation } from 'react-router-dom';
import { ActivityIndicator, Modal, Tabs, Toast } from 'antd-mobile';
import { Mask } from 'antd-mobile-v5';
import styles from './visitForm.module.scss';
import FormField from '../../component/formField/FormField';
import QuestionSurveyForm from '../../component/formField/questionSurveyForm';
import { ApiCore } from '../../api';
import { Models } from 'rmc-tabs';
import { createFromIconfontCN } from '@ant-design/icons';
import backBtn from '../../static/icon/back_button.png';
import FileIcon from '../../static/images/file_icon.png';
import axios from 'axios';
import { PhotoSlider } from 'react-photo-view';
import utils from '../../utils/utils';
import CRFComponent from '../../component/crf';
import icon_task_video_collect from '../../static/images_doctor/icon_task_video_collect.png';
import icon_video_complete from '../../static/images_doctor/rwd/icon_video_complete.png';
import icon_video_ing from '../../static/images_doctor/rwd/icon_video_ing.png';
import icon_video_no_pass from '../../static/images_doctor/rwd/icon_video_no_pass.png';
import icon_video_no_sign from '../../static/images_doctor/rwd/icon_video_no_sign.png';
import icon_video_remain_audit from '../../static/images_doctor/rwd/icon_video_remain_audit.png';
import verify, { replaceFieldRule } from '../../utils/verify';
import {GlobalValueItem, isReadOnly, JSFormLock, ValueItem} from '../../component/formField/utils';

const alert = Modal.alert;
const api = new ApiCore();
//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_4gqrz3ri63f.js',
});

function VisitForm(props: any, ref: any) {
    
    const urlParams = utils.getUrlParams() || {};
    const crfRef = useRef();
    // crf表单
    let crfData = sessionStorage.getItem('crfParams');
    let newCrfData: any = null;
    if (crfData) {
        newCrfData = JSON.parse(crfData)
    }
    let token = sessionStorage.getItem('token');
    let mToken: any = {};
    if (token) {
        try {
            mToken = JSON.parse(token);

        } catch (error) {
            mToken = {};
        }
    }
    let isNewUI = mToken && mToken.tenantConfig && mToken.tenantConfig.enableNewUi;
    const [isOriginPage, setIsOriginPage] = useState<any>(urlParams.isOriginPage || !isNewUI || '');
    //区分是否是展示在之前的页面
    const [inPrePage, setInPrePage] = useState<boolean>(props.inPrePage);
    //设置加载状态
    const [loading, setLoading] = useState<boolean>(false);

    //ocr上传状态
    const [uploadLoading, setUploadLoading] = useState<boolean>(false);

    //设置tabs
    const [tabs, setTabs] = useState<any>([]);

    //设置fieldList
    const [fieldList, setFieldList] = useState<any>();

    //设置当前选择的tab id
    const [selectTabId, setSelectTabId] = useState<string>('');

    //当前tabs的索引
    const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

    //当前表单的状态
    const [formState, setFormState] = useState<any>();

    //是否显示底部按钮
    const [showFormBtn, setShowFormBtn] = useState(false);

    //表单组件
    const formRef = useRef<any>(null);

    //OCR图片数组
    const [ocrFileList, setOcrFileList] = useState<any>([]);

    //选中的ocr图片index
    const [selectOcrIndex, setSelectOcrIndex] = useState<any>();

    //图片预览是否可见
    const [photoVisible, setPhotoVisible] = useState<boolean>(false);

    // formCode OCR识别需要用到
    const [formCode, setFormCode] = useState<any>();

    // version OCR识别需要用到
    const [version, setVersion] = useState<any>();

    // 表单冻结
    const [freezeState, setFreezeState] = useState('')
    // 患者状态
    const [subjectState, setSubjectState] = useState('')

    // crf表单初始化
    const [crfParams, setCrfParams] = useState<any>(newCrfData || {});
    // crf表单只读
    const [crfReadonly, setCrfReadonly] = useState<any>(false);
    // crf表单保存
    const [crfSaveData, setCrfSaveData] = useState<any>(null);
    const [crfSaveType, setCrfSaveType] = useState<any>('');
    // crf表单加载时的遮罩层
    const [showMask, setShowMask] = useState<any>(true);
    // crf表单数据修改时
    const [crfFormChange, setCrfFormChange] = useState<any>(false);
    // 项目类型 QUESTIONSURVEY
    const [projectType, setProjectType] = useState<string>(urlParams.projectType || '');
    // 锁定状态
    const [lockState, setLockState] = useState<any>(null);

    // formCenterCode 表单所在中心的code
    const [formCenterCode, setFormCenterCode] = useState<any>('');

    // 全局
    const [formValues, setFormValues] = useState<ValueItem[]>([])
    const [globalValues, setGlobalValues] = useState<GlobalValueItem[]>([])

    const [ autoOcr, setAutoOcr]= useState<Number>(0)

    const [readonly, setReadonly] = useState(false)

    // 新属性-编辑状态
    const editModel = Number(sessionStorage.editModel);

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;
    const location = useLocation();  
    useImperativeHandle(ref, () => ({
        dealVideo
    }));


    const dealVideo = () => {
        if (formRef.current.vedioFile) {
            formRef.current.dealSameVideo()
        }
    }

    useEffect(() => {
        
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');

        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }

        // 锁定状态
        let formLockState = sessionStorage.getItem('formLockState');
        if (formLockState) {
            setLockState(formLockState)
        }

        return () => {
            sessionStorage.removeItem('formLockState')
        }

    }, [])
    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {
        if (!inPrePage) {
            document.title = '访视表单';
        }
        let localStorage_forms = localStorage.getItem('localStorage_forms');
        if (localStorage_forms) {
            let forms = JSON.parse(localStorage_forms);
            let tabs = forms.forms;
            let activeId = forms.activeId;
            let state = forms.state;
            setAutoOcr(forms.autoOcr)
            setTabs(tabs);
            setSelectTabId(activeId);
            setFormState(state);

            //设置当前tab的索引
            setCurrentTabIndex(tabs.findIndex((item: any) => {
                return item.id == activeId;
            }))

            // crf
            if (newCrfData) {
                newCrfData.recordCode = activeId
                if (tabs && tabs.length > 0) {
                    let index = tabs.findIndex((item: any) => {
                        return item.id == activeId;
                    })
                    newCrfData.crfCode = tabs[index].code

                    if (tabs[index].inputState == 'Complete') {
                        setCrfReadonly(true)
                    } else {
                        setCrfReadonly(false)
                    }
                }

                setCrfParams(newCrfData)
                sessionStorage.setItem('crfParams', JSON.stringify(newCrfData))
            }
        }

    }, [])
    // 返回逻辑处理,针对小程序的地图选点功能返回，做了单独处理，跳转到指定页面，略过小程序地图选择页面
    const goBack = ()=>{
        const formUrl = localStorage.getItem("formUrl")
        console.log(location.pathname)
        if(formUrl){
           props.history.push({ pathname: localStorage.getItem("pathname")})
        }else{
           props.history.go(-1)
        }
            
    }

    //当选择的tab发生变化
    const onChangeTab = (tab: Models.TabData, index: number) => {
        // crf
        if (newCrfData) {
            if (!crfFormChange) {
                changeTabFun(tab, index)
                return
            }

            // crf 表单修改时提示 crfFormChange:true
            alert('', '数据尚未保存，是否先保存？', [
                {
                    text: '取消', onPress: () => {
                        setCrfFormChange(false)
                        changeTabFun(tab, index)
                    }
                },
                {
                    text: '保存', onPress: () => {
                        // 暂存
                        if (crfRef.current) {
                            setCrfSaveType('')
                            // @ts-ignore
                            crfRef.current.handleSave()
                        }
                        setCrfFormChange(false)
                        changeTabFun(tab, index)
                    }
                }
            ])
        } else {
            changeTabFun(tab, index)
        }
    }

    const changeTabFun = (tab: any, index: number) => {
        // crf
        if (newCrfData) {
            if (index == currentTabIndex) {
                return
            }
            setShowMask(true)
            if (index > currentTabIndex && (index - currentTabIndex > 1)) {
                let localStorage_forms = localStorage.getItem('localStorage_forms');
                if (localStorage_forms) {
                    let forms = JSON.parse(localStorage_forms);
                    forms.activeId = tab.id
                    forms.state = tab.inputState

                    localStorage.setItem('localStorage_forms', JSON.stringify(forms));
                }
                window.location.reload();
            }

            if (crfRef.current) {
                // @ts-ignore
                crfRef.current.unloadApp()
            }

            newCrfData.recordCode = tab.id
            newCrfData.crfCode = tab.code
            setCrfParams(newCrfData)
            sessionStorage.setItem('crfParams', JSON.stringify(newCrfData))
        }

        if (tabs[index].inputState == 'Complete') {
            setCrfReadonly(true)
        } else {
            setCrfReadonly(false)
        }

        setCurrentTabIndex(index);
        setSelectTabId(tab.id);
        setSelectOcrIndex(undefined);
    }

    //当选择的tab发生变化时
    useEffect(() => {
        updateFormDataById();
    }, [selectTabId])


    //根据formId更新数据
    const updateFormDataById = async() => {
       
        if (!selectTabId) {
            return
        }

        setLoading(true);

        const {code, data} = await api.getFormTemplateById({
            id: selectTabId
        })

        if (code != '0' || !data) {
            return
        }
        
        // !!!君实 - 表单锁定特殊处理
        if (editModel === 1) {
            await JSFormLock.handlefast(Number(selectTabId), data)
        }

        setLoading(false);
        setFreezeState(data.freezeState)
        setSubjectState(data.subjectState)
        setFormCenterCode(data.centerCode || '')
        setFormCode(data.formCode);
        setVersion(data.version);             
        setFieldList(Object.assign(data));
        setOcrFileList(data.ocrFiles);
        setGlobalValues(data.globalValues ?? [])
        setFormValues(data.values ?? [])
        setShowFormBtn(false);

        //判断是否存在需要操作的函数
        const pieces = ['FormActionSubmit', 'FormActionQuestion', 'FormActionExamine', 'FormActionFreeze', 'FormActionAutograph', 'FormActionLock', 'FormActionCancelQuestion', 'FormActionCancelExamine', 'FormActionCancelFreeze', 'FormActionCancelAutograph', 'FormActionCancelLock'];
        for (const item of data.formActions) {
            if(pieces.includes(item)) {
                setShowFormBtn(true);
                break
            }
        }
    }

    // 查找某个表单
    const filterForm = (arr: any, savedValues: any) => {
        for (let item of arr) {
            if (item.children && item.children.length > 0) {
                let _item: any = filterForm(item.children, savedValues)
                if (_item) {
                    return _item
                }
            }
            else if (savedValues) {
                let findItem = savedValues.find((i: any) => { return i.dataCode === item.dataCode })
                if (!findItem || findItem.value === '' || findItem.value.length === 0) {
                    return item;
                }
            }
        }
    }


    //处理group类型规则
    const dealValidationRulesGroup = (data: any) => {
        let validationRules: any = []
        data.forEach((item: any) => {
            if (item.children) {
                let _data = dealValidationRulesGroup(item.children)
                validationRules = [...validationRules, ..._data]
            } else {
                validationRules.push(item)
            }
        });
        return validationRules
    }
    const filterNoVaildData = (validationRulesAll: any, savedValues: any) => {
        const vaildDataArr: any = [];
        validationRulesAll.forEach((item: any) => {
            if (item.display && item.display.type === 'ValueCascade') {

                if (item.display.condition === 'eq') {
                    //当前选中表单已存的value
                    let currentItem = savedValues.find((i: any) => {
                        return i.dataCode == item.display.target
                    });
                    if (currentItem) {
                        if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                            vaildDataArr.push(item)
                        }
                    }
                }
                // else if (item.display.condition === 'andEq') {
                //     let judgeArr = [];
                //     for (let i = 0; i < item.display.target.length; i++) {
                //         let findedItem = savedValues.find((valueItem: any) => {
                //             return valueItem.dataCode === item.display.target[i]
                //         });
                //         if (findedItem) {
                //             if (findedItem.value instanceof Array) {
                //                 if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                //                     judgeArr.push(false);
                //                 }
                //                 else {
                //                     judgeArr.push(true);
                //                 }
                //             }
                //             else {
                //                 if (findedItem.value !== item.display.rule[i]) {
                //                     judgeArr.push(false);
                //                 }
                //                 else {
                //                     judgeArr.push(true);
                //                 }
                //             }
                //         }
                //         else {
                //             judgeArr.push(false)
                //         }
                //     }
                //     if (judgeArr.every(item => {
                //         if (item === true) {
                //             return true
                //         }
                //     })) {
                //           vaildDataArr.push(item)
                //     }
                // }
                // else if (item.display.condition === 'orEq') {
                //     let judgeArr = [];
                //     for (let i = 0; i < item.display.target.length; i++) {
                //         let findedItem = savedValues.find((valueItem: any) => {
                //             return valueItem.dataCode === item.display.target[i]
                //         });
                //         if (findedItem) {
                //             if (findedItem.value instanceof Array) {
                //                 if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                //                     judgeArr.push(false);
                //                 }
                //                 else {
                //                     judgeArr.push(true);
                //                 }
                //             }
                //             else {
                //                 if (findedItem.value !== item.display.rule[i]) {
                //                     judgeArr.push(false);
                //                 }
                //                 else {
                //                     judgeArr.push(true);
                //                 }
                //             }
                //         }
                //         else {
                //             judgeArr.push(false)
                //         }
                //     }
                //     if (judgeArr.indexOf(true) !== -1) {
                //          vaildDataArr.push(item)
                //     }
                // }

            } else {
                vaildDataArr.push(item)
            }
        });

        return vaildDataArr;
    }

    // 提交
    const onSubmit = () => {
        // return;
        if (formRef.current) {
            let params = formRef.current.getSavedForm();
            // let findItem = filterForm(fieldList.body, params.values);
            // console.log(findItem)
            // if (findItem) {
            //     Toast.fail(`提交失败,${findItem.label}不能为空！`, 1)
            // }
            // else {
            if (fieldList && fieldList.body) {

                let validationRules: any = [];
                fieldList.body.forEach((element: any) => {
                    validationRules.push(element.children);
                    // todo children可能有多层
                });
                // 铺平
                let validationRulesAll: any = [];
                validationRules.forEach((outVal: any) => {
                    outVal.forEach((inVal: any) => {
                        validationRulesAll.push(inVal);
                    });
                });
                validationRulesAll = dealValidationRulesGroup(validationRulesAll)

                //过滤到不需要校验的数据，一些不显示的数据二级数据
                validationRulesAll = filterNoVaildData(validationRulesAll, params.values);

                // feature: 处理number字段和number字段数值比较
                validationRulesAll.forEach(({ validationRules }: any)=> {
                    replaceFieldRule(validationRules, params.values)
                })
                
                const notValid = validationRulesAll.some((val: any) => {
                    // 匹配的数据
                    let value = (params.values.find((v: any) => v.dataCode == val.dataCode));
                    if (!value) {
                        return;
                    }
                    let judge = verify.checkValueByRange(value.value, val);
                    let judge1 = verify.checkValueByRep(value.value, val);
                    if (!judge || !judge1) {
                        if (!judge1) {
                            Toast.info('请输入正确的格式！', 1)
                        }else if(!judge){
                            debugger;
                            Toast.info('请输入正确的格式！', 1)
                        }
                        return true;
                    }
                })
                if (notValid) {
                    return;
                }
            }

            setLoading(true);
            api.saveForm(params).then(res => {
                if (res.code == '0') {
                    Toast.success('提交成功！', 1)

                    // 相同大小视频处理 
                    if (formRef.current.vedioFile) {
                        formRef.current.dealSameVideo()
                    }

                    // 若列表数为一：返回上一页
                    if (tabs && tabs.length === 1) {
                        // props.history.go(-1)
                        goBack()
                    }
                    //若列表数大于一默认选中下一表单
                    else if (tabs && tabs.length > 1) {
                        let nextTabIndex = currentTabIndex + 1;
                        if (nextTabIndex === tabs.length) {
                            // props.history.go(-1)
                            goBack()
                        }
                        else if (nextTabIndex < tabs.length) {
                            setSelectTabId(tabs[nextTabIndex].id);
                            setCurrentTabIndex(nextTabIndex);
                        }
                    }

                }
                else {
                    updateFormDataById();
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
            // }
        }
        // crf表单
        else if (crfRef.current) {
            setCrfSaveType('crf_submit')
            // @ts-ignore
            crfRef.current.handleSubmit()
        }
        else {
            Toast.fail('提交失败！', 1)
        }
    }

    //通过人工核查
    const onQuestion = () => {
        console.log('人工核查操作')
        if (selectTabId) {
            let params = {
                action: 'FormActionQuestion',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('通过人工核查成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('通过人工核查失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //取消人工核查
    const onCancelQuestion = () => {
        console.log('取消人工核查')
        if (selectTabId) {
            let params = {
                action: 'FormActionCancelQuestion',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('取消人工核查', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('取消人工核查失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //通过数据核查
    const onExamine = () => {
        console.log('通过数据核查')
        if (selectTabId) {
            let params = {
                action: 'FormActionExamine',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('通过数据核查成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('通过数据核查失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //取消数据核查
    const onCancelExamine = () => {
        console.log('取消数据核查')
        if (selectTabId) {
            let params = {
                action: 'FormActionCancelExamine',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('取消数据核查成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('取消数据核查失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //解冻
    const onCancelFreeze = () => {
        console.log('解冻')
        if (selectTabId) {
            let params = {
                action: 'FormActionCancelFreeze',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('解冻成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('解冻失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //冻结
    const onFreeze = () => {
        console.log('冻结')
        if (selectTabId) {
            let params = {
                action: 'FormActionFreeze',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('冻结成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('冻结失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //取消签名
    const onCancelAutograph = () => {
        console.log('取消签名')
        if (selectTabId) {
            let params = {
                action: 'FormActionCancelAutograph',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('取消签名成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('取消签名失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //签名
    const onAutograph = () => {
        console.log('签名')
        if (selectTabId) {
            let params = {
                action: 'FormActionAutograph',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('签名成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('签名失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //解锁
    const onCancelLock = () => {
        console.log('解锁')
        if (selectTabId) {
            let params = {
                action: 'FormActionCancelLock',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('解锁成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('解锁失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //锁定
    const onLock = () => {
        console.log('锁定')
        if (selectTabId) {
            let params = {
                action: 'FormActionLock',
                formId: selectTabId
            }
            setLoading(true);
            api.updateFormState(params).then(res => {
                if (res.code == '0') {
                    setFieldList(res.data)
                    Toast.success('锁定成功！', 1)
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('锁定失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //OCR拍照上传
    const onOcrUpload = () => {
        let ele = document.getElementById('OcrUpload');
        ele?.click();
    }

    //当上传文件改变
    const onOcrUploadChange = (e: any) => {
        setUploadLoading(true);
        let uploadFormData = new FormData();
        uploadFormData.append("file", e.target.files[0]);
        axios.post(`/data/form/${selectTabId}/image`, uploadFormData, {
            headers: { "Content-Type": "multipart/form-data" }
        }).then(res => {
            if (res.data.code === 0) {
                let params = {
                    formId: selectTabId,
                    images: [...ocrFileList, res.data.data]
                }
                api.updateOcrList(params).then(res => {
                    if (res.code == '0') {
                        Toast.success('上传成功！', 1)
                        setOcrFileList(res.data)
                    }
                    setUploadLoading(false);
                })
            }
            else {
                if (res.data.message) {
                    Toast.fail(`${res.data.message}`, 1);
                    setUploadLoading(false);
                }
                else {
                    Toast.fail(`上传失败！`, 1);
                    setUploadLoading(false);
                }
            }
        })
    }

    //switch 操作按钮
    const switchActionBtn = (item: any) => {
        if ((sessionStorage.forceReadonly && freezeState === 'Complete') || isReadOnly(formCode)) {
            return null
        }

        switch (item) {
            //查看
            case 'FormActionRead':
                return null
            //保存
            case 'FormActionSave':
                return null
            //提交
            case 'FormActionSubmit':
                if (editModel === 1 || lockState !== 'Complete') {
                    return (
                        <div className={styles.positiveBtn} onClick={onSubmit}>
                            <IconFont type="iconsubmit"></IconFont>
                            提交
                        </div>
                    )
                }
                return null
            //通过人工核查
            case 'FormActionQuestion':
                return (
                    <div className={styles.positiveBtn} onClick={onQuestion}>
                        <IconFont type="iconQuestion_icon"></IconFont>
                        通过人工核查
                    </div>
                )
            //取消人工核查
            case 'FormActionCancelQuestion':
                return (
                    <div className={styles.reverseBtn} onClick={onCancelQuestion}>
                        <IconFont type="iconQuestion_icon"></IconFont>
                        取消人工核查
                    </div>
                )
            //数据核查
            case 'FormActionExamine':
                return (
                    <div className={styles.positiveBtn} onClick={onExamine}>
                        <IconFont type="iconExamine_icon"></IconFont>
                        通过数据核查
                    </div>

                )
            //取消数据核查
            case 'FormActionCancelExamine':
                return (
                    <div className={styles.reverseBtn} onClick={onCancelExamine}>
                        <IconFont type="iconExamine_icon"></IconFont>
                        取消数据核查
                    </div>
                )
            //冻结
            case 'FormActionFreeze':
                return (
                    <div className={styles.positiveBtn} onClick={onFreeze}>
                        <IconFont type="iconFreeze_icon"></IconFont>
                        冻结
                    </div>

                )
            //解冻
            case 'FormActionCancelFreeze':
                return (
                    <div className={styles.reverseBtn} onClick={onCancelFreeze}>
                        <IconFont type="iconFreeze_icon"></IconFont>
                        解冻
                    </div>
                )
            //签名
            case 'FormActionAutograph':
                return (
                    <div className={styles.positiveBtn} onClick={onAutograph}>
                        <IconFont type="iconAutograph_icon"></IconFont>
                        签名
                    </div>

                )
            //取消签名
            case 'FormActionCancelAutograph':
                return (
                    <div className={styles.reverseBtn} onClick={onCancelAutograph}>
                        <IconFont type="iconAutograph_icon"></IconFont>
                        取消签名
                    </div>
                )
            //锁定
            case 'FormActionLock':
                return (
                    <div className={styles.positiveBtn} onClick={onLock}>
                        <IconFont type="iconLock_icon"></IconFont>
                        锁定
                    </div>

                )
            //取消锁定
            case 'FormActionCancelLock':
                return (
                    <div className={styles.reverseBtn} onClick={onCancelLock}>
                        <IconFont type="iconLock_icon"></IconFont>
                        解锁
                    </div>
                )
            //OCR上传
            case 'FormActionOcrUpload':
                return (
                    ''
                    // <div className={styles.positiveBtn} onClick={onOcrUpload}>
                    //     <input accept="image/*" type="file" value="" name="upload" id="OcrUpload" onChange={onOcrUploadChange} style={{ display: 'none' }} />
                    //     <IconFont type="iconOcr_icon"></IconFont>
                    //     拍照上传
                    // </div>
                )
            // 修改
            case 'DataActionUpdate':
                return (
                    <div className={styles.positiveBtn} onClick={onUpdate}>
                        修改
                    </div>
                )
            default:
                break;
        }
    }

    //ocr图片ocrListView
    const ocrListView = () => {
        let isShow = false;
        if (ocrFileList && ocrFileList.length > 0) {
            isShow = true;
        }
        if (isShow) {
            return (
                <div className={styles.ocrListContent}>
                    {
                        <div className={selectOcrIndex === undefined ? styles.selectWordBtnChecked : styles.selectWordBtn} onClick={() => { setSelectOcrIndex(undefined) }}>
                            <IconFont type="iconWord"></IconFont>
                        </div>
                    }
                    {
                        ocrFileList && ocrFileList.length > 0 && ocrFileList.map((item: any, index: any) => {
                            return (
                                <React.Fragment key={index}>
                                    <div className={index === selectOcrIndex ? styles.ocrImgItemChecked : styles.ocrImgItem} onClick={() => { setSelectOcrIndex(index) }}>
                                        <img src={item} alt={`img${index}`} />
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                </div>
            )
        }
        else {
            return null
        }
    }

    const ocrView = () => {
        return (
            <div className={styles.ocrViewContent} onClick={() => { setPhotoVisible(true) }}>
                <img src={ocrFileList[selectOcrIndex]} alt="" />
            </div>
        )
    }

    //删除照片
    const onDelectOcr = () => {
        alert('Delete', '确定删除照片吗？', [
            { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
            {
                text: '确认', onPress: () => {
                    let filterArr = [];
                    for (let i = 0; i < ocrFileList.length; i++) {
                        if (selectOcrIndex !== i) {
                            filterArr.push(ocrFileList[i])
                        }
                    }
                    let params = {
                        formId: selectTabId,
                        images: filterArr
                    }
                    api.updateOcrList(params).then(res => {
                        if (res.code == '0') {
                            Toast.success('删除成功！', 1)
                            setOcrFileList(res.data)
                            if (res.data.length === 0) {
                                setSelectOcrIndex(undefined);
                            }
                            else {
                                if (selectOcrIndex - 1 >= 0) {
                                    setSelectOcrIndex(selectOcrIndex - 1);
                                }
                                else {
                                    setSelectOcrIndex(selectOcrIndex);
                                }
                            }
                        }
                        setUploadLoading(false);
                    })
                }
            },
        ])
    }

    // crf表单保存
    const onSaveSuccess = (values: any) => {

        if (values) {
            setCrfSaveData(values)

            // 修改
            if (crfSaveType == 'crf_update') {
                let params = {
                    formId: newCrfData.recordCode,
                    dataCode: '',
                    deCode: '',
                    value: []
                }
                api.updateCrfData(params).then(res => {
                    if (res.code == '0') {
                        Toast.success('修改成功！', 1)
                        // props.history.go(-1)
                        goBack()
                    }
                    else {
                        Toast.fail(res.message, 1)
                    }
                })
                return
            }

            // 提交
            if (crfSaveType == 'crf_submit') {
                let params = {
                    formId: newCrfData.recordCode,
                    submit: true,
                    values: []
                }
                api.saveCrfForm(params).then(res => {
                    if (res.code == '0') {
                        Toast.success('提交成功！', 1)
                        // props.history.go(-1)
                        goBack()
                    }
                })
                return
            }
        }
    }

    // crf表单修改
    const onUpdate = () => {
        setCrfSaveType('crf_update')
        // @ts-ignore
        crfRef.current.handleSubmit()
    }

    // crf 加载成功关闭遮罩层 false->关闭
    const initCrfSuccess = (value: any) => {
        setShowMask(value)
    }

    // crf 表单数据修改时
    const handleValuesChange = (value: any) => {
        setCrfFormChange(value)
    }

    // 视频征集对应状态文案
    const statusToText = () => {
        let subjectsData = props.subjectsData;
        console.log('subjectsData', subjectsData);
        if (!subjectsData || Object.keys(subjectsData).length == 0) {
            return null;
        }
        if (subjectsData.auditState) {
            if (subjectsData.auditState === 'Wait') {
                return '待审核';
            } else if (subjectsData.auditState === 'Pass') {
                return '已审核';
            } else if (subjectsData.auditState === 'Fail') {
                return '未通过';
            }
        } else {
            if (subjectsData.state === 'Init') {
                return '待入组';
            } else if (subjectsData.state === 'Active') {
                return '进行中';
            } else if (subjectsData.state === 'Finish' && subjectsData.signState === 'Wait') {
                return '未签名';
            } else if (subjectsData.state === 'Finish') {
                return '已完成';
            }
        }
        return <></>;
    }
    const getRandom = ()=>{
        return Math.random()
    }

    // 视频征集对应状态图标
    const statusToImg = () => {
        let subjectsData = props.subjectsData;
        if (!subjectsData || Object.keys(subjectsData).length == 0) {
            return null;
        }
        if (subjectsData.auditState) {
            if (subjectsData.auditState === 'Wait') {
                return <img src={icon_video_remain_audit} alt="" />;
            } else if (subjectsData.auditState === 'Pass') {
                return <img src={icon_video_complete} alt="" />;
            } else if (subjectsData.auditState === 'Fail') {
                return <img src={icon_video_no_pass} alt="" />;
            }
        } else {
            if (subjectsData.state === 'Init') {
                return null;
            } else if (subjectsData.state === 'Active') {
                return <img src={icon_video_ing} alt="" />;
            } else if (subjectsData.state === 'Finish' && subjectsData.signState === 'Wait') {
                return <img src={icon_video_no_sign} alt="" />;
            } else if (subjectsData.state === 'Finish') {
                return <img src={icon_video_complete} alt="" />;
            }
        }
        return <></>;
    }

    return (
        <>
            {newCrfData && <Mask visible={showMask} opacity='thin'>
                <ActivityIndicator animating={true} size={"small"} text={'正在加载数据'} toast />
            </Mask>}
            <div className={`${styles.visitForm_content} ${inPrePage ? styles.pre_page_content : ''} ${newCrfData ? styles.crf_page : ''} ${(fieldList &&
                fieldList.body &&
                selectOcrIndex === undefined) && projectType === 'QUESTIONSURVEY' && !isOriginPage ? styles.question_survey : ''
                } ${projectType === 'VIDEOSOLICIT' && !isOriginPage ? styles.video_collect : ''} `}>
                {
                    projectType === 'VIDEOSOLICIT' && !isOriginPage &&
                    <div className={styles.pre_page_video_header}>
                        <div className={styles.text_wrap}>
                            <div className={styles.text_wrap_left}>
                                <img src={icon_task_video_collect} alt="" />
                            </div>
                            <div className={styles.text_wrap_right}>
                                <div>{props.subjectsData?.code}</div>
                                <div>
                                    {statusToImg()}
                                    <span>
                                        {statusToText()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className={`${(projectType === 'VIDEOSOLICIT' && !isOriginPage) ? styles.video_collect_content : ''}`}>
                    {
                        projectType === 'VIDEOSOLICIT' && !isOriginPage &&
                        <div className={styles.pre_page_video_title_wrap}>
                            {/* <img src={FileIcon} alt="" /> */}
                            <div className={styles.pre_page_video_title_text}>
                                <span className={styles.video_title_text}>
                                    {
                                        tabs && tabs[0] && tabs[0].title
                                    }
                                </span>
                                <div className={styles.video_title_text_icon}></div>
                            </div>
                            <div className={`${styles.qrcodeGap_conent}`}>
                                <div className={`${styles.line}  ${styles.extraGap}`}></div>
                                <div className={`${styles.doc_l} ${styles.doc_l_left}`}></div>
                                <div className={`${styles.doc_r} ${styles.doc_r_right}`}></div>
                            </div>
                        </div>
                    }
                    {
                        inPrePage && projectType !== 'QUESTIONSURVEY' && projectType !== 'VIDEOSOLICIT' &&
                        <div className={styles.pre_page_title_wrap}>
                            <img src={FileIcon} alt="" />
                            {
                                tabs && tabs[0] && tabs[0].title
                            }
                        </div>
                    }
                    <Tabs tabs={tabs} tabBarUnderlineStyle={{ borderColor: '#6287EC' }} tabBarBackgroundColor="transparent" tabBarInactiveTextColor="#9A9FAB" swipeable={false} animated={false} page={currentTabIndex} renderTabBar={props => <Tabs.DefaultTabBar {...props} page={3} />} onTabClick={(tab, index) => { onChangeTab(tab, index) }} renderTab={tab => <span>{tab.title}1</span>}>
                        {
                            newCrfData &&
                              
                                tabs && tabs.length > 0 && tabs.map((item: any, index: any) => (
                                    <div key={index} className={`${styles.crf_form_content}`}>
                                        {
                                            selectTabId == item.id &&
                                            <CRFComponent
                                                // @ts-ignore
                                                ref={crfRef}
                                                params={crfParams}
                                                onSaveSuccess={(v: any) => onSaveSuccess(v)}
                                                // readonly={crfReadonly}
                                                readonly={false}
                                                initCrfSuccess={(v: any) => initCrfSuccess(v)}
                                                handleValuesChange={(v: any) => handleValuesChange(v)}
                                            />
                                        }
                                    </div>
                                ))
                        }
                    </Tabs>

                    {
                         !newCrfData && <div style={{ height: showFormBtn ? 'calc(100vh - 2.24rem)' : 'calc(100vh - 1.2rem)' }} className={`${styles.form_content} ${(inPrePage && projectType !== 'VIDEOSOLICIT') ? styles.pre_content : ''} ${(projectType === 'VIDEOSOLICIT' && !isOriginPage) ? styles.video_form_content : ''}`}>
                                    {
                                        ocrListView()
                                    }
                                    {
                                        (fieldList &&
                                            fieldList.body &&
                                            selectOcrIndex === undefined) && (projectType !== 'QUESTIONSURVEY' || isOriginPage) ?
                                            <FormField
                                                readonly={isReadOnly(formCode)}
                                                autoOcr={autoOcr}
                                                formId={selectTabId}
                                                formCode={formCode}
                                                formCenterCode={formCenterCode}
                                                version={version}
                                                fieldList={fieldList}
                                                ref={formRef}
                                                updateData={updateFormDataById}
                                                globalValues={globalValues}
                                            ></FormField>
                                            :
                                            (fieldList &&
                                                fieldList.body &&
                                                selectOcrIndex === undefined) && projectType === 'QUESTIONSURVEY'
                                                ?
                                                <QuestionSurveyForm
                                                    formId={selectTabId}
                                                    formCode={formCode}
                                                    version={version}
                                                    fieldList={fieldList}
                                                    ref={formRef}
                                                    updateData={updateFormDataById}
                                                ></QuestionSurveyForm>
                                                :
                                                null
                                    }
                                    {
                                        selectOcrIndex !== undefined ? ocrView() : null
                                    }
                                    {
                                        selectOcrIndex === undefined && showFormBtn && inPrePage ? <div className={`${styles.save_content} ${styles.save_content_prepage}`} style={{ backgroundColor: lockState && lockState == 'Complete' ? 'transparent' : '#fff' }}>
                                            {
                                                fieldList && fieldList.formActions && fieldList.formActions.map((item: any, index: any) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {
                                                                switchActionBtn(item)
                                                            }
                                                        </React.Fragment>
                                                    )
                                                })
                                            }
                                        </div> : null
                                    }
                                </div> 

                }

                    {/* crf 表单
            提交 crfReadonly:false
            修改 crfReadonly:true */}
                    {
                        newCrfData &&
                        <div className={styles.save_content} style={{ backgroundColor: lockState && lockState == 'Complete' ? 'transparent' : '#fff' }}>
                            {
                                fieldList ?
                                    (
                                        fieldList.formActions && !crfReadonly ?
                                            (
                                                fieldList.formActions.map((item: any, index: any) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {
                                                                switchActionBtn(item)
                                                            }
                                                        </React.Fragment>
                                                    )
                                                })
                                            ) :
                                            (
                                                fieldList.dataActions && crfReadonly ?
                                                    (
                                                        fieldList.dataActions.map((item: any, index: any) => {
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    {
                                                                        switchActionBtn(item)
                                                                    }
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    ) : null
                                            )
                                    ) : null
                            }
                        </div>
                    }

                    {
                        selectOcrIndex === undefined && showFormBtn && !inPrePage ? <div className={styles.save_content} style={{ backgroundColor: lockState && lockState == 'Complete' ? 'transparent' : '#fff' }}>
                            {
                                fieldList && fieldList.formActions && fieldList.formActions.map((item: any, index: any) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                switchActionBtn(item)
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                        </div> : null
                    }
                    {
                        selectOcrIndex !== undefined && showFormBtn ? <div className={styles.save_content} style={{ backgroundColor: lockState && lockState == 'Complete' ? 'transparent' : '#fff' }}>
                            {/* <div className={styles.positiveBtn} onClick={onOcrUpload}>
                        <input accept="image/*" type="file" value="" name="upload" id="OcrUpload" onChange={onOcrUploadChange} style={{ display: 'none' }} />
                        <IconFont type="iconOcr_icon"></IconFont>
                        拍照上传
                    </div> */}
                            <div className={styles.positiveBtn} onClick={onDelectOcr}>
                                <IconFont type="iconDelete_icon"></IconFont>
                                删除照片
                            </div>
                        </div> : null
                    }
                    <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

                    <ActivityIndicator animating={uploadLoading} size={"small"} text={'上传中，请稍等...'} toast />

                    {/* 操作按钮 */}
                    <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                        <img src={backBtn} alt="back" onClick={ goBack} />
                    </div>

                    {/* 图片预览 */}
                    <PhotoSlider
                        photoClosable
                        bannerVisible={true}
                        images={ocrFileList && ocrFileList.map((item: any) => ({ src: item }))}
                        visible={photoVisible}
                        onClose={() => { setPhotoVisible(false) }}
                        index={selectOcrIndex}
                        introVisible={true}
                        onIndexChange={(i: any) => { setSelectOcrIndex(i) }}
                    />
                </div>
            </div>
        </>
    )
}

export default forwardRef(VisitForm);